// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import createCache from "@emotion/cache";

export default function createEmotionCache() {
  return createCache({ key: "css", prepend: true });
}
